export const botLabels = {
  ru: {
    title: 'Помощник библиотеки', launcher: 'Задать вопрос', close: 'Закрыть',
    loading: 'Открываем помощника…', welcome: 'Здравствуйте! Помогу с вопросами о библиотеке. Напишите вопрос или выберите тему.',
    question: 'Ваш вопрос', placeholder: 'Например: до скольки работает библиотека?', send: 'Спросить',
    allQuestions: 'Все вопросы', fewerQuestions: 'Скрыть список', clarify: 'Уточните, что вы имели в виду:',
    unknown: 'Не нашёл подходящего ответа. Попробуйте уточнить вопрос или напишите менеджеру библиотеки.',
    manager: 'Написать менеджеру', back: 'Вернуться к вопросам', name: 'ФИО', email: 'E-mail', phone: 'Телефон',
    contactHint: 'Откроется WhatsApp с вашим вопросом и контактами. Нажмите «Отправить» в WhatsApp, чтобы менеджер получил сообщение.',
    openWhatsApp: 'Открыть WhatsApp', language: 'Язык ответов',
    contactTitle: 'Вопрос менеджеру библиотеки', phoneError: 'Укажите телефон: не менее 7 цифр.',
    popupError: 'Не удалось открыть WhatsApp. Разрешите всплывающее окно и попробуйте снова.'
  },
  kz: {
    title: 'Кітапхана көмекшісі', launcher: 'Сұрақ қою', close: 'Жабу',
    loading: 'Көмекші ашылуда…', welcome: 'Сәлеметсіз бе! Кітапхана туралы сұрақтарға көмектесемін. Сұрақ жазыңыз немесе тақырып таңдаңыз.',
    question: 'Сұрағыңыз', placeholder: 'Мысалы: кітапхана нешеге дейін жұмыс істейді?', send: 'Сұрау',
    allQuestions: 'Барлық сұрақтар', fewerQuestions: 'Тізімді жасыру', clarify: 'Қай сұрақты меңзегеніңізді нақтылаңыз:',
    unknown: 'Сәйкес жауап табылмады. Сұрақты нақтылап көріңіз немесе кітапхана менеджеріне жазыңыз.',
    manager: 'Менеджерге жазу', back: 'Сұрақтарға оралу', name: 'Аты-жөніңіз', email: 'E-mail', phone: 'Телефон',
    contactHint: 'WhatsApp сұрағыңыз бен байланыс деректеріңізбен ашылады. Менеджер хабарламаны алуы үшін WhatsApp-та «Жіберу» батырмасын басыңыз.',
    openWhatsApp: 'WhatsApp ашу', language: 'Жауап тілі',
    contactTitle: 'Кітапхана менеджеріне сұрақ', phoneError: 'Телефон нөмірін енгізіңіз: кемінде 7 цифр.',
    popupError: 'WhatsApp ашылмады. Қалқымалы терезеге рұқсат беріп, қайта көріңіз.'
  },
  en: {
    title: 'Library assistant', launcher: 'Ask a question', close: 'Close',
    loading: 'Opening the assistant…', welcome: 'Hello! I can help with library questions. Type a question or choose a topic.',
    question: 'Your question', placeholder: 'For example: when does the library close?', send: 'Ask',
    allQuestions: 'All questions', fewerQuestions: 'Hide the list', clarify: 'Which question did you mean?',
    unknown: 'I could not find a suitable answer. Try a more specific question or contact the library manager.',
    manager: 'Contact the manager', back: 'Back to questions', name: 'Full name', email: 'Email', phone: 'Phone',
    contactHint: 'WhatsApp will open with your question and contact details. Press Send in WhatsApp so the manager receives your message.',
    openWhatsApp: 'Open WhatsApp', language: 'Answer language',
    contactTitle: 'Question for the library manager', phoneError: 'Enter a phone number with at least 7 digits.',
    popupError: 'WhatsApp could not be opened. Allow the pop-up and try again.'
  }
}
